import Menubar from './MenubarLinks'

// ARIA Compatible Menu
export const initMenuDesktop = () => {
  const menuBars = document.querySelectorAll('.menu')
  
  for (let menu of menuBars) {
    if (menu.querySelectorAll('.nav__item--has-children').length > 0) {
      let menuBar = new Menubar(menu)
      menuBar.init()
    }
  }
}

export default initMenuDesktop


